import { teaches } from './order';

const UNFINISHED =
  'This scene is not finished, so the preview has nothing to open yet.';
const NOT_PLAYED =
  'The preview only opens on a teaching scene — the reward comes at the end of a run.';

/**
 * Why the preview cannot open straight onto this scene, or nothing — GEN-90.
 *
 * The two refusals are the two ways a row is dropped before the run ever sees it:
 * `playableScenes` holds back a scene that does not parse, and `LessonRun` filters out
 * whatever `sceneTeaches` says is not played. A button offered over either would land on
 * the cover, which reads as the jump being broken rather than as work still to do.
 */
export function jumpRefusal(
  kind: string,
  playable: boolean,
): string | undefined {
  if (!playable) return UNFINISHED;

  return teaches(kind) ? undefined : NOT_PLAYED;
}
